import { render } from "./TranscoderSettings.vue?vue&type=template&id=0dff0c9c"
import script from "./TranscoderSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscoderSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Transcoder/TranscoderSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dff0c9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dff0c9c', __exports__)) {
    api.reload('0dff0c9c', __exports__)
  }
  
  module.hot.accept("./TranscoderSettings.vue?vue&type=template&id=0dff0c9c", () => {
    api.rerender('0dff0c9c', render)
  })

}


export default __exports__